// Minimal HUD for the driving prototype. Real screens come with the fares milestone.

export class Hud {
  readonly root: HTMLElement;
  private money: HTMLElement;
  private clock: HTMLElement;
  private debug: HTMLElement;
  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.innerHTML = `
      <div class="panel hud-money"><small>Fares</small><span data-money>$0</span></div>
      <div class="panel hud-clock"><small>Time left</small><span data-clock>10:00</span></div>
      <div class="panel hud-debug" data-debug hidden></div>
      <span class="hud-hint" style="left:calc(50% - 170px);bottom:calc(18px + var(--safe-b))">tap left to honk</span>
      <span class="hud-hint" style="left:calc(50% + 70px);bottom:calc(18px + var(--safe-b))">hold right to brake</span>`;
    parent.appendChild(this.root);
    this.money = this.root.querySelector('[data-money]')!;
    this.clock = this.root.querySelector('[data-clock]')!;
    this.debug = this.root.querySelector('[data-debug]')!;
  }
  setMoney(v: number): void { this.money.textContent = `$${Math.round(v).toLocaleString()}`; }
  setClock(seconds: number): void { const s = Math.max(0, Math.ceil(seconds)); this.clock.textContent = `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; }
  setDebug(text: string | null): void { if (text == null) { this.debug.hidden = true; return; } this.debug.hidden = false; this.debug.textContent = text; }
}

export function setupFullscreenButton(button: HTMLElement): void {
  const doc = document as Document & { webkitFullscreenElement?: Element; webkitExitFullscreen?: () => void };
  const el = document.documentElement as HTMLElement & { webkitRequestFullscreen?: () => void };
  const isFs = () => !!(document.fullscreenElement || doc.webkitFullscreenElement);
  button.addEventListener('click', async () => {
    try {
      if (isFs()) { if (document.exitFullscreen) await document.exitFullscreen(); else doc.webkitExitFullscreen?.(); }
      else {
        if (el.requestFullscreen) await el.requestFullscreen({ navigationUI: 'hide' });
        else el.webkitRequestFullscreen?.();
        try { await (screen.orientation as ScreenOrientation & { lock?: (o: string) => Promise<void> }).lock?.('landscape'); } catch { /* not allowed everywhere */ }
      }
    } catch { /* iOS Safari on iPhone has no fullscreen API; the button still exists so the layout is stable */ }
  });
  const render = () => { button.classList.toggle('on', isFs()); };
  document.addEventListener('fullscreenchange', render); document.addEventListener('webkitfullscreenchange', render);
}

export class LoadingScreen {
  readonly el: HTMLElement;
  private msg: HTMLElement; private bar: HTMLElement;
  constructor(parent: HTMLElement) {
    this.el = document.createElement('div'); this.el.className = 'loading';
    this.el.innerHTML = `<div class="logo">CAB<br><b>CALAMITY</b></div><div class="bar"><i></i></div><div class="msg">Warming up the taxi…</div>`;
    parent.appendChild(this.el);
    this.msg = this.el.querySelector('.msg')!; this.bar = this.el.querySelector('.bar i')!;
  }
  set(label: string, fraction: number): void { this.msg.textContent = label; this.bar.style.width = `${Math.round(fraction * 100)}%`; }
  remove(): void { this.el.remove(); }
}
